module.exports = __webpack_public_path__ + "img/icon-arrow-bottom.6456ef19.svg";